import Icon from "./Icon.jsx";
import { SignalChip } from "./Chip.jsx";
import { truncate } from "../lib/format.js";

export default function MetricCards({ actions, signals, learned }) {
  return (
    <div className="a a3" style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 10 }}>
      <Card icon="check" color="var(--green)" title="Ready to send" value={actions.length} caption="Actions pending">
        {actions.slice(0, 2).map((a, i) => (
          <Row key={i}>{truncate(a.action, 45)}</Row>
        ))}
      </Card>

      <Card icon="bolt" color="var(--volt)" fill title="Signals" value={signals.length} caption="Detected">
        {signals.slice(0, 2).map((s, i) => (
          <Row key={i} flex>
            <SignalChip type={s.type} />
            <span style={{ fontSize: 10, color: "var(--t3)" }}>{s.company}</span>
          </Row>
        ))}
      </Card>

      <Card icon="brain" color="var(--purple)" title="Learned" value={learned.length} caption="Insights">
        {learned.slice(0, 2).map((l, i) => (
          <Row key={i}>{truncate(l.text, 50)}</Row>
        ))}
      </Card>
    </div>
  );
}

function Card({ icon, color, fill, title, value, caption, children }) {
  return (
    <div
      style={{
        background: "var(--s1)",
        border: "1px solid var(--brd)",
        borderRadius: 10,
        padding: 16,
      }}
    >
      <div
        style={{
          fontSize: 12,
          fontWeight: 600,
          marginBottom: 8,
          display: "flex",
          alignItems: "center",
          gap: 5,
        }}
      >
        <Icon name={icon} size={14} color={color} fill={fill} />
        {title}
      </div>
      <div style={{ fontFamily: "var(--d)", fontSize: 26, fontWeight: 700 }}>{value}</div>
      <div style={{ fontSize: 10, color: "var(--t3)", marginBottom: 6 }}>{caption}</div>
      {children}
    </div>
  );
}

function Row({ children, flex }) {
  return (
    <div
      style={{
        fontSize: 11,
        color: "var(--t2)",
        marginTop: 4,
        paddingTop: 4,
        borderTop: "1px solid var(--brd)",
        lineHeight: 1.4,
        ...(flex ? { display: "flex", justifyContent: "space-between", alignItems: "center" } : {}),
      }}
    >
      {children}
    </div>
  );
}
